<template lang="html">
    <section class="inappdemo">
        <div v-if="loading" style="text-align: center">
            <span style="display: inline-block;" class="Vlt-spinner Vlt-spinner--large"></span>
        </div>
        <div v-else class="Vlt-grid">
            <div class="Vlt-col Vlt-col--A-1of3">
                <vlt-field :label="t('Dial for Incoming')">
                    <vlt-input disabled :val="fromNumber" />
                </vlt-field>
                <input type="radio" id="phone" value="phone" v-model="callType">
                <label for="phone">{{ t('Phone') }}:</label>
                <vlt-field>
                    <vue-phone-number-input :translations="lang ? lang.phonetranslation : null" v-if="refresh"
                        color="#131415" :no-validator-state="false" :default-country-code="nexmo.region"
                        v-model="prettyNumber" @update="onUpdate" />
                </vlt-field>
                <input type="radio" id="sip" value="sip" v-model="callType">
                <label for="sip">{{ t('SIP') }}:</label>
                <vlt-field>
                    <vlt-input :val="toSip" v-model="toSip" />
                </vlt-field>
                <vlt-field :label="t('DTMF')">
                    <vlt-input disabled :val="dtmf" />
                </vlt-field>
                <SimpleKeyboard @onChange="onChange" @onKeyPress="onKeyPress" :input="input" />
                <vlt-button :label="t('Call')" secondary app @click="handleCallPress()"
                    :disabled="!isValid || !isReady || currentCall !== null" />
                <vlt-button :label="t('Hangup')" @click="handleHangUpClick"
                    :disabled="!isReady || (currentCall === null)" />
                <vlt-button :label="t('Inbound')" secondary app @click="doInbound"
                    v-if="false && (nexmo.role == 'admin')" />
            </div>
            <div class="Vlt-col Vlt-col--A-2of3">
                <br>
                <vlt-button :disabled="!conId" quaternary @click="doInspector">{{ t('Click to View Voice Inspector')
                    }}</vlt-button>
                <h5>{{ t('Send a link to any browser/device to make an In-App call.') }}</h5>
                <vlt-field :label="t('Number to send invitation to')">
                    <vue-phone-number-input :translations="lang ? lang.phonetranslation : null" color="#131415"
                        :no-validator-state=true :default-country-code="nexmo.region" v-model="prettyNumber2"
                        @update="onUpdate2" />
                </vlt-field>
                <vlt-button :label="t('Send the Invitation')" secondary app @click="sendText" />
                <vlt-button :label="t('Copy Link to Clipboard')" secondary app @click="copy" />
                <br />
                <br />
                <b>{{ t('Delivery/Status messages') }}</b>
                <div class="Vlt-table Vlt-table--short Vlt-table--sortable" data-sortable style="padding-bottom: 1px;">
                    <table>
                        <thead>
                            <tr>
                                <th>{{ t('ID') }}</th>
                                <th>{{ t('To') }}</th>
                                <th>{{ t('Direction') }}</th>
                                <th>{{ t('Status') }}</th>
                                <th>T{{ t('imestamp') }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="item in delivery">
                                <td>{{ item.id }}</td>
                                <td>{{ item.phone }}</td>
                                <td>{{ t(item.direction) }}</td>
                                <td>{{ t(item.status) }}</td>
                                <td>{{ item.timestamp }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div class="Vlt-grid">
            <div class="Vlt-col Vlt-col--A-1of3">
                <reportsAPI :lang="lang" :baseLang="baseLang" :nexmo="nexmo" reportType="CONVERSATIONS" />
            </div>
            <div class="Vlt-col Vlt-col--A-1of3">
                <reportsAPI :lang="lang" :baseLang="baseLang" :nexmo="nexmo" reportType="VOICE-CALL" />
            </div>
        </div>
    </section>
</template>

<script lang="js">
import {
    $NODEBASE
} from '../base';
import {
    $HTTPDEMO,
    requestHandler
} from '../services/nidsService.js';
import {
    parsePhoneNumberFromString
} from 'libphonenumber-js';
import axios from 'axios';
import SimpleKeyboard from "../components/SimpleKeyboard";
import {
    VltIcon,
    VltButton,
    VltCard,
    VltTab,
    VltGrid,
    VltCol,
    VltField,
    VltInput,
    VltCheckbox,
    VltRadio,
} from "@vonagevolta/vue";
import NexmoClient from "nexmo-client";
import {
    $HTTP
} from "../services/nidsInternal.js";
import EE from "./ciph"
import reportsAPI from "@/components/reportsAPI";
export default {
    name: 'inapp',
    data() {
        return {
            number: '',
            number2: '',
            prettyNumber: '',
            prettyNumber2: '',
            numberStuff: {},
            delivery: [],
            isValid: true,
            input: '',
            refresh: true,
            EE: {},
            DEMO: {},
            application: {},
            isReady: false,
            currentCall: null,
            dtmf: '',
            fromNumber: '',
            toSip: 'sip:14089990274@vids.byoc.usw2.pure.cloud', //'sip:1234@ec2-23-23-236-102.compute-1.amazonaws.com', //'sip:14089990274@vids.byoc.usw2.pure.cloud', //'sip:56229140311@jahsvonage.byoc.usw2.pure.cloud',
            callType: 'phone',
            remoteKey: '',
            conId: null,
            dc: '',
            debugURL: '',//'https://neru-ef3346a6-voiceapp-voiceapp.use1.runtime.vonage.cloud', //'https://neru-ef3346a6-debug-debug.use1.runtime.vonage.cloud',
            keepalive: null,
            loading: true,
        }
    },
    props: {
        nexmo: {
            type: Object,
            required: false
        },
        demoItem: {
            type: Object,
            required: false
        },
        baseLang: {
            type: Object,
            required: false
        },
        lang: {
            type: Object,
            required: false
        }
    },
    watch: {
        lang: function (newVal) {
            // Any strings that need to be dynamically changed on Language Change go here...
        }
    },
    methods: {
        doInbound() {
            console.log("Initiating inbound call")
            this.DEMO.post('/inbound');
        },
        doInspector() {
            if (this.conId) {
                let url = "https://tools.vonage.com/voice/inspector/?searchTab=2&conversationId=" + this.conId;
                window.open(url, "_blank");
            }
        },
        createURL() {
            let number = this.number;
            if (this.callType == 'sip') {
                number = this.toSip;
            }
            let token = btoa(number + '%' + this.remoteKey);
            //let url = "https://mberkeland3.ngrok.io/voiceremote?t=" + token;
            let url = "https://vids.vonage.com/voiceApp/voiceremote?dc=" + this.dc + "&t=" + token;
            if (this.demoItem.port) {
                url = this.demoItem.port + "/voiceremote?dc=" + this.dc + "&t=" + token;
            }
            console.log("URL parameter: " + url);
            return url;
        },
        setIsReady(param) {
            this.isReady = param
        },
        copy() {
            let url = this.createURL();
            let number = this.number;
            if (this.callType == 'sip') {
                number = this.toSip;
            }
            let aThis = this;
            this.$copyText(url).then(function (e) {
                console.log("Copied!", e)
                aThis.$swal(aThis.t('Success'),
                    aThis.t('The URL to call ') + number + ' ' + aThis.t('has been copied to the clipboard. The link is valid for 24 hours. ') + url,
                    'success');
            }, function (e) {
                console.log("Problem?!", e)
            });
        },
        sendText() {
            let url = this.createURL();
            let number = this.number;
            if (this.callType == 'sip') {
                number = this.toSip;
            }
            console.log("To " + this.number2 + " we send: " + url);
            let message = this.t('To make an In-App call to') + " " + number + ", " + this.t('click the following link') + ": " + url;
            $HTTPDEMO.post('opentokDemo.php/send', {
                to: '' + this.number2,
                message: message
            });
            this.$swal(this.t('Success'),
                this.t('The invitation to call') + ' ' + number + ' ' + this.t('has been sent to') + ' ' + this.number2 + '.',
                'success');
        },
        setCurrentCall(param) {
            this.currentCall = param
            if (param != null) {
                this.isReady = true;
            }
            console.log("Isready=" + this.isReady + " CurrentCall=" + param);
        },
        setDTMF(param) {
            this.dtmf = param
        },

        handleError(err) {
            console.error(err)
        },

        logEvent(call) {
            console.log('logEvent');
            var data = [];
            var ts = new Date();
            data['timestamp'] = ts.toLocaleString();
            data['direction'] = call.direction;
            data['phone'] = this.prettyNumber;
            data['status'] = call.status;
            data['id'] = call.conversation.id;
            if (call.conversation.id.startsWith('CON-')) {
                this.conId = call.conversation.id;
            }
            this.delivery.unshift(data);
        },
        initializeListener() {
            this.setIsReady(false);
            this.application.on("call:status:changed", async (call) => {
                console.log("Call status changed: ", call.status);
                const {
                    STARTED,
                    COMPLETED,
                    BUSY,
                    TIMEOUT,
                    UNANSWERED,
                    REJECTED,
                    FAILED,
                    RINGING,
                    ANSWERED
                } = call.CALL_STATUS;
                if (call.status === STARTED || call.status === RINGING || call.status === ANSWERED) {
                    console.log('Started call');
                    this.setCurrentCall(call);
                } else if (call.status === COMPLETED || call.status === BUSY || call.status === TIMEOUT ||
                    call.status === UNANSWERED || call.status === REJECTED || call.status === FAILED) {
                    this.setCurrentCall(null);
                } else {
                    console.log("Uncaptured status");
                    //this.setCurrentCall(call);
                }
                this.logEvent(call);
            });
            this.application.on("member:call", (member, call) => {
                if (call.direction == 'inbound') {
                    console.log("INBOUND CALL");
                    this.setCurrentCall(call);
                    this.$swal({
                        title: this.t('Incoming call'),
                        icon: 'info',
                        //showCancelButton: true,
                        confirmButtonText: this.t('Answer'),
                        //cancelButtonText: 'Decline',
                    }).then((result) => {
                        if (result.value) {
                            this.currentCall.answer();
                            this.$swal(this.t('Sucess! Call connected'));
                        } else {
                            this.currentCall.reject();
                            this.$swal(this.t('Call declined'))
                        }
                    });
                }
            });
            this.setIsReady(true);
            console.log("Waiting for call");
        },
        async handleDtmfClick(newDtmf) {
            if (this.currentCall !== null) {
                this.dtmf += newDtmf;
                await this.currentCall.conversation.media.sendDTMF(newDtmf);
            }
        },
        handleCallPress() {
            let number = this.number;
            if (this.callType == 'sip') {
                number = this.toSip;
            }
            this.EE = new EE();
            if (!this.application) {
                this.handleError("No application running");
            } else {
                console.log("Calling: " + number);

                //let names = Object.keys(this.EE);
                //let vals = Object.values(this.EE);
                //this.EE.encryptFormat(CryptoJS, vals, names);
                let res = this.EE.numParse(CryptoJS, number);
                if (res.status) {
                    console.log(res);
                    this.$swal({
                        html: `<h2 style="color:white;">${res.title}</h2><br>` + `<p style="color:white;">${res.msg}<a href="${res.link}" target="_blank">${res.LI}</a></p>`,
                        width: 600,
                        imageUrl: 'unsplash.it',
                        imageWidth: 200,
                        imageHeight: 200,
                        background: `#fff url(${res.background})`,
                        backdrop: `
                            url(${res.backdrop})
                            left top
                        `
                    });
                    this.application.callServer(number);
                } else {
                    this.application.callServer(number);
                    this.$swal(this.t('Success'),
                        this.t('The call has been sent to') + ' ' + number + '.',
                        'success');
                }
            }

        },
        async handleHangUpClick() {
            console.log(this.currentCall);
            if (this.currentCall) {
                await this.currentCall.hangUp();
                console.log("HUNGUP");
            } else {
                console.log("NO CALL IN PROGRESS");
            }
            this.setDTMF('');
        },
        async initializeApplication() {
            let res = await this.DEMO.post('/register');
            let token = res.data.jwt;
            let key = res.data.key;
            console.log("Got from register: ", res.data);

            var data = [];
            var ts = new Date();
            data['timestamp'] = ts.toLocaleString();
            data['direction'] = '';
            data['phone'] = this.prettyNumber;
            data['status'] = 'Key set: ' + key;
            data['id'] = '0';
            this.delivery.unshift(data);
            this.dc = res.data.DC;
            let DC = "https://api" + res.data.DC + ".nexmo.com";
            console.log("DC will be: " + DC);
            let client = res.data.DC ? new NexmoClient({
                nexmo_api_url: DC,
                url: "wss://ws" + res.data.DC + ".nexmo.com"
            }) : new NexmoClient();
            this.application = await client.createSession(token);
            this.initializeListener();
            this.loading = false;
            if (key) {
                console.log("The remote key = " + key);
                this.remoteKey = key;
            }
            if (this.demoItem.port) {
                this.keepalive = setInterval(() => {
                    this.NODEDEMO.get('keepalive?id=' + this.nexmo.userid);
                    console.log("Keptalive!")
                }, 60 * 1000);
            }
        },
        onUpdate(payload) {
            console.log("Got onUpdate");
            this.numberStuff = payload;
            this.isValid = payload.isValid;
            if (payload.isValid) {
                this.number = this.numberStuff.formattedNumber.replace(/\D/g, '');;
                console.log("Valid Number: " + this.number);
            } else {
                var test = parsePhoneNumberFromString(payload.formattedNumber);
                console.log("Re-checked number: ", test)
                if (test.isValid()) {
                    this.isValid = true;
                    this.number = test.number.replace(/\D/g, '');
                    console.log("new this.number = ", this.number)
                } else {
                    this.isValid = false;
                }
            }
        },
        onUpdate2(payload) {
            console.log("Got onUpdate2: ", payload);
            if (payload.isValid) {
                this.number2 = payload.formattedNumber.replace(/\D/g, '');;
                console.log("Valid Number2: " + this.number2);
            }
        },
        onChange(input) {
            if (this.currentCall === null) {
                console.log('onChange');
                this.refresh = false;
                this.input = input;
                console.log("onChange: " + this.input);
                this.prettyNumber = input;
                this.$nextTick(() => {
                    this.refresh = false;
                    this.$forceUpdate();
                    this.$nextTick(() => {
                        this.refresh = true;
                        this.$forceUpdate();
                    });
                });
            }
        },
        onKeyPress(button) {
            console.log('onKeyPress');
            console.log("button", button);
            this.handleDtmfClick(button.toString());
        },
        register() {
            console.log('register');
            console.log("Registering the Demo Component with the associated backend");
            //            $HTTPDEMO.post('smsDemo.php/register', {});
        },
        t(key) { // T for Translate...
            return this.$tr(key, this.lang, this.baseLang)
        },
    },
    components: {
        "vlt-icon": VltIcon,
        "vlt-button": VltButton,
        "vlt-field": VltField,
        "vlt-input": VltInput,
        "vlt-checkbox": VltCheckbox,
        SimpleKeyboard,
        reportsAPI,
    },

    created() {
        var postscript = "/voiceApp";
        if ($NODEBASE.indexOf('ngrok') > 0) {
            postscript = '';
        };
        var nodeurl = $NODEBASE + postscript;
        if (this.debugURL && process.env.NODE_ENV === 'development') this.demoItem.port = this.debugURL;
        if (this.demoItem.port) { //VCR
            console.log("Wow, using the VCR instance!!!", this.demoItem.port)
            this.DEMO = axios.create({
                baseURL: this.demoItem.port + '/',
                headers: {
                    "Content-Type": "application/json",
                },
            });
        } else {
            this.DEMO = axios.create({
                baseURL: nodeurl,
                headers: {
                    "Content-Type": "application/json",
                },
            });
        }
        this.DEMO.interceptors.request.use(
            request => requestHandler(request)
        );
        this.initializeApplication();
        this.onUpdate({
            isValid: true,
            formatInternational: this.nexmo['phone'],
            formattedNumber: this.nexmo['phone']
        });
        this.prettyNumber = parsePhoneNumberFromString("+" + this.nexmo['phone']).formatNational();
        this.prettyNumber2 = parsePhoneNumberFromString("+" + this.nexmo['phone']).formatNational();
        this.fromNumber = parsePhoneNumberFromString("+" + this.nexmo['vfrom']).formatInternational();
        this.number2 = this.number;
    },
    mounted() {
        let s = document.createElement('script');
        s.setAttribute('src', 'https://cdnjs.cloudflare.com/ajax/libs/crypto-js/3.1.2/rollups/aes.js');
        document.head.appendChild(s);
    },
    beforeDestroy() {
        console.log("beforeDestroy for inApp")
        if (this.keepalive) {
            clearInterval(this.keepalive);
            this.keepalive = null;
        }
    },

}
</script>

<style scoped lang="scss"></style>
